import {
  AccountCircleOutlined,
  AddTaskOutlined,
  ChevronLeftOutlined,
  ChevronRightOutlined,
  DescriptionOutlined,
  FolderOutlined,
  LogoutOutlined,
} from "@mui/icons-material";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import { ReactElement, useContext, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { AppContext } from "../context/app-context";
import { Roles } from "../types/roles";

export default function MainSidebar(): ReactElement {
  const [isOpen, setOpen] = useState<boolean>(false);
  const currentLocation = window.location.pathname;
  const [searchParams] = useSearchParams();
  const { role } = useContext(AppContext);
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();

  const routeListItems = [
    {
      label: "Files",
      icon: <DescriptionOutlined className="text-[22px]" />,
      route: "/",
    },
    // {
    //   label: "Files",
    //   icon: <DescriptionOutlined className="text-[22px]" />,
    //   route: "/files",
    // },
    {
      label: "Collections",
      icon: <FolderOutlined className="text-[22px]" />,
      route: "/collections",
    },
  ];

  // Temporary exclude #29
  if (role && role !== Roles.regular) {
    routeListItems.push({
      label: "Approvals",
      icon: <AddTaskOutlined className="text-[22px]" />,
      route: "/approvals",
    });
  }

  function onClick(route: string): void {
    navigate(`${route}?${searchParams}`);
  }

  function toAccount(): void {
    location.href = `${keycloak.authServerUrl}realms/${
      keycloak.realm
    }/account/?referrer=${keycloak.clientId}&referrer_uri=${encodeURIComponent(
      window.location.origin
    )}`;
  }

  if (!keycloak.authenticated) {
    return <></>;
  }

  return (
    <Drawer
      variant="permanent"
      anchor="left"
      open={isOpen}
      PaperProps={{
        className: `fixed transition-all overflow-hidden shadow border ${
          isOpen ? "w-[120px]" : "w-[50px]"
        }`,
      }}
      className={`sticky z-50 overflow-hidden transition-all ${
        isOpen ? "w-[120px]" : "w-[50px]"
      }`}
    >
      <List>
        <ListItem disablePadding className="border-b">
          <ListItemButton
            onClick={() => setOpen(!isOpen)}
            className="min-h-[75px] justify-center"
          >
            {isOpen ? <ChevronLeftOutlined /> : <ChevronRightOutlined />}
          </ListItemButton>
        </ListItem>
        {routeListItems.map((element) => (
          <ListItem
            key={element.route}
            disablePadding
            className="border-b justify-center"
          >
            <ListItemButton
              onClick={() => onClick(element.route)}
              className={`relative min-h-[75px] flex-col items-center justify-center transition-all ${
                isOpen ? "w-100" : "w-0"
              }`}
            >
              <ListItemIcon
                className={`justify-center ${
                  currentLocation === process.env.PUBLIC_URL + element.route
                    ? "fill-company [&>svg]:fill-company"
                    : "fill-companyDarkGrey [&>svg]:fill-companyDarkGrey"
                }`}
              >
                {element.icon}
              </ListItemIcon>
              <ListItemText
                className={`flex-none [&>span]:text-[14px] overflow-hidden text-center text-lg transition-all ${
                  isOpen ? "max-h-32 opacity-100" : "max-h-0 opacity-0"
                } ${
                  currentLocation === process.env.PUBLIC_URL + element.route
                    ? "text-company"
                    : "text-companyDarkGrey"
                } pl-3`}
              >
                {element.label}
              </ListItemText>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <List className="mt-auto">
        <ListItem disablePadding className="border-b justify-center">
          <ListItemButton
            onClick={toAccount}
            className={`relative flex-col items-center justify-center transition-all ${
              isOpen ? "w-100" : "w-0"
            }`}
          >
            <ListItemIcon className="justify-center fill-companyDarkGrey [&>svg]:fill-companyDarkGrey">
              <AccountCircleOutlined />
            </ListItemIcon>
            <ListItemText
              className={`flex-none [&>span]:text-[14px] overflow-hidden text-center text-lg transition-all ${
                isOpen ? "max-h-32 opacity-100" : "max-h-0 opacity-0"
              }  text-companyDarkGrey pl-3`}
            >
              Account
            </ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding className="border-b justify-center">
          <ListItemButton
            onClick={() => keycloak.logout()}
            className={`relative flex-col items-center justify-center transition-all ${
              isOpen ? "w-100" : "w-0"
            }`}
          >
            <ListItemIcon className="justify-center fill-companyDarkGrey [&>svg]:fill-companyDarkGrey">
              <LogoutOutlined />
            </ListItemIcon>
            <ListItemText
              className={`flex-none [&>span]:text-[14px] overflow-hidden text-center text-lg transition-all ${
                isOpen ? "max-h-32 opacity-100" : "max-h-0 opacity-0"
              }  text-companyDarkGrey pl-3`}
            >
              Logout
            </ListItemText>
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
}
